import "core-js/modules/es.array.map";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import classnames from "classnames";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-designer-rail.css";
var DESIGNER_CATEGORY = "DESIGNER_CATEGORY";
export function HomepageDesignerItem(_ref) {
  var item = _ref.item,
      type = _ref.type;
  var isDesignerCategory = type == DESIGNER_CATEGORY;
  return React.createElement("a", {
    className: classnames(styles.homepageDesignerItem, _defineProperty({}, styles.homepageDesignerCategoryItem, isDesignerCategory)),
    href: item.url
  }, React.createElement(LazyLoadImage, {
    className: classnames(styles.homepageDesignerImg, _defineProperty({}, styles.homepageDesignerCategoryImg, isDesignerCategory)),
    src: item.image_url,
    alt: item.image_alt
  }), React.createElement("span", {
    className: classnames(styles.homepageDesignerLink, _defineProperty({}, styles.homepageDesignerCategoryLink, isDesignerCategory))
  }, item.title));
}
export function HomepageDesignerRail(_ref2) {
  var items = _ref2.items,
      type = _ref2.type,
      _ref2$analyticsLabel = _ref2.analyticsLabel,
      analyticsLabel = _ref2$analyticsLabel === void 0 ? "homepage_designer_rail" : _ref2$analyticsLabel;
  var buttonStyle = classnames(styles.scrollButton, _defineProperty({}, styles.scrollCategory, type === DESIGNER_CATEGORY));
  var leftButtonStyle = classnames(buttonStyle, styles.left);
  var rightButtonStyle = classnames(buttonStyle, styles.right);
  return React.createElement(Rail, {
    className: styles.homepageDesignerRail,
    analyticsLabel: analyticsLabel,
    title: "",
    leftButtonStyle: leftButtonStyle,
    rightButtonStyle: rightButtonStyle,
    buttonIcon: "square-chevron"
  }, items.map(function (item) {
    return React.createElement(HomepageDesignerItem, {
      key: item.url,
      item: item,
      type: type
    });
  }));
}
export default HomepageDesignerRail;